export const config = {
    appname: 'devapp',
    app_id: '2439493236332961', // App ID
    facebook_app_id: '2439493236332961', // Facebook App ID (Should be the same)
    debug: true, //enable console.log

    // ------------- Development Settings ----------------
    api: 'dev',
    bzbsUrl: 'https://apiservicecenter.buzzebees-dev.com',
    bzbsModuleUrl: 'https://apimodule.buzzebees-dev.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule.buzzebees-dev.com',
    webShoppingCartUrl: 'https://shoppingcartservice.buzzebees-dev.com',
    bzbsBlobUrl: 'https://devstoragebuzzebees.blob.core.windows.net',
    miscUrl: 'https://misc.buzzebees-dev.com',
    // ------------------ End Settings ---------------------

    // --------------------- Recaptcha ---------------------
    recaptchaSiteKey: "6LeSnaAmAAAAAM8nTr70vcd-gBwNnrv06XjpZz-6",

    webApi: 'http://localhost:3000',
    // webApi: '',

    firebase: {
        // apiKey: "",
        // authDomain: "testtracking-b23b5.firebaseapp.com",
        // databaseURL: "https://testtracking-b23b5.firebaseio.com",
        // projectId: "testtracking-b23b5",
        // storageBucket: "testtracking-b23b5.appspot.com",
        // messagingSenderId: "995876078913",
        // appId: "1:995876078913:web:c3298d1b004a0f6b9a4dc0",
        // measurementId: "G-M5CE0Q8SX6"
    },
};
